import {VGLawCookie} from "vglawcookie";

window.VegasListener = {
	onReady: () => {
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.scrollToCourse();

		if (App.snowEnabled) {
			Vegas.snow();
		}
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization", "color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		// navigation
		new VGNav({
			expand: 'md',
			toggle: '<i class="fal fa-chevron-down"></i>'
		});

		// animation
		AOS.init({
			once: true,
		});

		// Scrollbar
		let $scrollbarNav = $('.scrollbar-inner');
		if ($scrollbarNav.length) {
			$scrollbarNav.scrollbar();
		}

		// Tooltip
		$('[data-toggle=tooltip], [data-tooltip]').tooltip();

		// Nice select
		$('.nice-select').niceSelect();

		new VGLawCookie({
			enableLinkMore: true,
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default, .page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		//$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	scrollToCourse: function () {
		setTimeout(function () {
			let $courseSidebar = $(".course-sidebar");

			if ($courseSidebar.length) {
				let $active = $courseSidebar.find('.course-lessons-box.active');
				let top = $active.position().top-$active.parent().position().top;
				$courseSidebar.animate({scrollTop: top}, 1000);
			}
		}, 100);
	},

	snow: function () {
		$('.vg-header-snow').snowfall({
			flakeCount: isMobile() ? 7 : 15,
			minSize: 1,
			round: true,
			flakeIndex: 10,
			maxSize: 4,
			minSpeed: isMobile() ? 0.5 : 1,
			maxSpeed: isMobile() ? 1 : 2,
			image: '/assets/_frontend/images/theme/snow3.png'
		});

		$('.vg-header-snow3').snowfall({
			flakeCount: isMobile() ? 7 : 30,
			minSize: 5,
			round: true,
			flakeIndex: 10,
			maxSize: 10,
			minSpeed: isMobile() ? 0.5 : 1,
			maxSpeed: isMobile() ? 1 : 3,
			image: '/assets/_frontend/images/theme/snow1.png'
		});

		$('.vg-header-snow2').snowfall({
			flakeCount: isMobile() ? 7 : 50,
			minSize: 1,
			round: true,
			flakeIndex: 10,
			maxSize: 3,
			minSpeed: isMobile() ? 0.5 : 1,
			maxSpeed: isMobile() ? 1 : 1,
			image: '/assets/_frontend/images/theme/2.png'
		});
	}
};
